export const pipe = (...functions) => args => functions.reduce((updatedArgs, fn) => fn(updatedArgs), args);